import Vue from 'vue'
import gqlApp from '@/graphql/app'
import gqlUser from '@/graphql/user'
import gqlColor from '@/graphql/color'
import gqlConfig from '@/graphql/config'
import gqlArticle from '@/graphql/article'
import gqlArticleDefault from '@/graphql/articleDefault'
import gqlMethod from '@/graphql/method'
import gqlConveyor from '@/graphql/conveyor'
import gqlCode from '@/graphql/code'
import gqlDesign from '@/graphql/design'
import gqlSize from '@/graphql/size'
import gqlProduct from '@/graphql/product'
import gqlImage from '@/graphql/image'
import gqlLocation from '@/graphql/location'
import gqlLabel from '@/graphql/label'
import gqlTemporaryStock from '@/graphql/temporaryStock'
import gqlTier from '@/graphql/tier'
import gqlOrder from '@/graphql/order'
import gqlOrderWholesaler from '@/graphql/orderWholesaler'
import gqlOrderDropshipping from '@/graphql/orderDropshipping'
import gqlDelivery from '@/graphql/delivery'
import gqlRefund from '@/graphql/refund'
import gqlInvoice from '@/graphql/invoice'
import gqlPrice from '@/graphql/price'
import gqlChange from '@/graphql/change'
import gqlGiftVoucher from '@/graphql/giftVoucher'
import gqlGiftMessage from '@/graphql/giftMessage'
import gqlSet from '@/graphql/set'
import gqlBonus from '@/graphql/bonus'
import gqlCustomer from '@/graphql/customer'
import gqlFaq from '@/graphql/faq'
import gqlFeedback from '@/graphql/feedback'
import gqlBan from '@/graphql/ban'
import gqlFraudCase, { fraudCasesClosedQueries } from '@/graphql/fraudCase'
import gqlFraudReport from '@/graphql/fraudReport'
import mDB from '@/mixins/db'

function appendOrderStatusHistory (order, status, createdBy, createdAt, historyStatus, historyCreatedBy) {
  if (!order || !status) return
  if (!order.statusHistory) order.statusHistory = []
  const at = createdAt || new Date().toISOString()
  const recordStatus = historyStatus || status
  const actor = historyCreatedBy || createdBy
  const last = order.statusHistory[order.statusHistory.length - 1]
  if (last && last.status === recordStatus && last.createdBy === (actor || '')) return
  order.statusHistory.push({
    status: recordStatus,
    createdBy: actor || '',
    createdAt: at
  })
}

const gqlQueries = {
  app: gqlApp,
  users: gqlUser,
  colors: gqlColor,
  articles: gqlArticle,
  designs: gqlDesign,
  images: gqlImage,
  codes: gqlCode,
  methods: gqlMethod,
  conveyors: gqlConveyor,
  locations: gqlLocation,
  articleDefaults: gqlArticleDefault,
  sizes: gqlSize,
  products: gqlProduct,
  labels: gqlLabel,
  tiers: gqlTier,
  temporaryStocks: gqlTemporaryStock,
  orders: gqlOrder,
  deliveries: gqlDelivery,
  prices: gqlPrice,
  orderWholesalers: gqlOrderWholesaler,
  ordersDropshipping: gqlOrderDropshipping,
  refunds: gqlRefund,
  invoices: gqlInvoice,
  configs: gqlConfig,
  changes: gqlChange,
  giftVouchers: gqlGiftVoucher,
  sets: gqlSet,
  giftMessages: gqlGiftMessage,
  bonuses: gqlBonus,
  customers: gqlCustomer,
  faqs: gqlFaq,
  feedbacks: gqlFeedback,
  bans: gqlBan,
  fraudCases: gqlFraudCase,
  fraudCasesClosed: fraudCasesClosedQueries,
  fraudReports: gqlFraudReport
}

const state = { isLoading: false }
const collections = ['users', 'colors', 'designs', 'articles', 'methods', 'conveyors', 'images', 'codes', 'locations', 'articleDefaults', 'products', 'sizes', 'labels', 'tiers', 'temporaryStocks', 'orders', 'deliveries', 'prices', 'orderWholesalers', 'ordersDropshipping', 'refunds', 'invoices', 'configs', 'changes', 'giftVouchers', 'sets', 'giftMessages', 'bonuses', 'customers', 'faqs', 'feedbacks', 'bans', 'fraudCases', 'fraudCasesClosed', 'fraudReports']

const createCollections = () => {
  collections.forEach(collection => {
    state[collection] = { data: { docs: [] }, new: [] }
    state[`${collection}History`] = { data: { docs: [] }, new: [] }
  })
}

createCollections()

export default {
  state,

  mutations: {
    changeCheckItem (state, { resolver, index, value }) {
      Vue.set(state[resolver].data.docs[index], 'checked', value)
    },

    changeCheckList (state, { resolver, value }) {
      state[resolver].data.docs.forEach(item => {
        Vue.set(item, 'checked', value)
      })
    },

    getVariablesApp () {
      this.dispatch('getVariablesApp')
    },

    getData (_, options) {
      this.dispatch('getData', options)
    },

    newData (state, message) {
      const { newData } = message
      let { resolver } = message

      if (resolver[resolver.length - 1] === 'y') {
        resolver = resolver.split('')
        resolver[resolver.length - 1] = 'ie'
        resolver = resolver.join('')
      } else if (resolver[resolver.length - 1] === 's') {
        resolver = resolver + 'e'
      }

      state[`${resolver}s`].data.totalDocs++
      state[`${resolver}s`].data.docs.unshift(newData)

      const order = newData.order
      const change = newData.change

      if (order && newData.isDropshipping) {
        state[`ordersDropshipping`].data.docs.unshift(newData)
      }

      // Add deliveries to orders
      if (order && !change && resolver === 'deliverie') {
        const orderFound = state.orders.data.docs.find(orderData => {
          return orderData.order === order
        })
        const orderFoundNew = state.orders.new.find(orderData => {
          return orderData.order === order
        })

        if (orderFound) orderFound.deliveries.push(newData)
        if (orderFoundNew) orderFoundNew.deliveries.push(newData)
      }

      // Add deliveries to orders
      if (order && change && resolver === 'deliverie') {
        const changeFound = state.changes.data.docs.find(changeData => {
          return changeData.change === change
        })
        const changeFoundNew = state.changes.new.find(changeData => {
          return changeData.change === change
        })

        if (changeFound) changeFound.deliveries.push(newData)
        if (changeFoundNew) changeFoundNew.deliveries.push(newData)
      }

      if (resolver === 'deliverie') {
        this.commit('mass/addMassDeliveryFromSocket', newData)
      }

      // Add refunds to orders
      if (order && resolver === 'refund') {
        const orderFound = state.orders.data.docs.find(orderData => {
          return orderData.order === order
        })
        const orderFoundNew = state.orders.new.find(orderData => {
          return orderData.order === order
        })

        if (orderFound) orderFound.refunds.push(newData)
        if (orderFoundNew) orderFoundNew.refunds.push(newData)
      }

      // Add changes to orders
      if (order && resolver === 'change') {
        const orderFound = state.orders.data.docs.find(orderData => {
          return orderData.order === order
        })
        const orderFoundNew = state.orders.new.find(orderData => {
          return orderData.order === order
        })

        if (orderFound) orderFound.changes.push(newData)
        if (orderFoundNew) orderFoundNew.changes.push(newData)
      }

      // Add invoice to orders
      if (order && resolver === 'invoice') {
        const orderFound = state.orders.data.docs.find(orderData => {
          return orderData.order === order
        })
        const orderFoundNew = state.orders.new.find(orderData => {
          return orderData.order === order
        })

        if (orderFound) orderFound.invoices.push(newData)
        if (orderFoundNew) orderFoundNew.invoices.push(newData)
      }
    },

    updateData (state, message) {
      const { dataUpdated, findBy } = message
      let { resolver } = message

      if (resolver[resolver.length - 1] === 'y') {
        resolver = resolver.split('')
        resolver[resolver.length - 1] = 'ie'
        resolver = resolver.join('')
      } else if (resolver[resolver.length - 1] === 's') {
        resolver = resolver + 'e'
      }

      if (resolver === 'user') {
        if (dataUpdated.dni === '1037633441') {
          this.commit('updateBalance', dataUpdated.balance)
        }
      }

      const k = resolver.search('order') >= 0 ? 3 : 1

      for (let i = 0; i < k; i++) {
        let resolverToFind = `${resolver}s`

        if (i === 1) {
          resolverToFind = 'orderWholesalers'
        }

        if (i === 2) {
          resolverToFind = 'ordersDropshipping'
        }

        const find = state[resolverToFind].data.docs.find(d => String(d[findBy]) === String(dataUpdated[findBy]))
        const findNew = state[resolverToFind].new.find(d => String(d[findBy]) === String(dataUpdated[findBy]))

        if (find || findNew) {
          const dataFind = find || findNew

          for (const key in dataFind) {
            if (dataFind.hasOwnProperty(key) && dataUpdated.hasOwnProperty(key)) {
              // Solucionar esto, lo hice para que no agregara nada al final del carro
              if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData' && key !== 'noveltyData') dataFind[key].push('')

              const value = (key === 'remitDataGenerated' || key === 'dataLocked' || key === 'hasNoveltyData' || key === 'hasProductChange')
                ? !!dataUpdated[key]
                : dataUpdated[key]

              if (key === 'remitData' || key === 'remitDataGenerated' || key === 'dataLocked' || key === 'hasNoveltyData' || key === 'noveltyData' || key === 'hasProductChange' || key === 'productChange' || key === 'productChangeHistory') {
                if (findNew) Vue.set(findNew, key, value)
                if (find) Vue.set(find, key, value)
              } else {
                if (findNew) findNew[key] = value
                if (find) find[key] = value
              }
            }
          }
        }
      }

      if (dataUpdated.order) {
        this.commit('pack/updatePackOrderFromSocket', dataUpdated)
        this.commit('mass/updateMassOrderFromSocket', dataUpdated)
        this.dispatch('orderNovelty/refreshFromSocket', dataUpdated)
      }

      if (dataUpdated.change) {
        this.commit('pack/updatePackChangeFromSocket', dataUpdated)
        this.commit('mass/updateMassChangeFromSocket', dataUpdated)
      }

      // Add deliveries to orders
      const delivery = dataUpdated.delivery

      if (delivery && resolver === 'deliverie') {
        this.commit('mass/updateMassDeliveryFromSocket', dataUpdated)

        for (let i = 0; i < state.orders.data.docs.length; i++) {
          const order = state.orders.data.docs[i]
          const deliveries = order.deliveries

          for (let j = 0; j < deliveries.length; j++) {
            const deliveryData = deliveries[j]

            if (deliveryData.delivery === delivery) {
              for (const key in dataUpdated) {
                if (Object.hasOwnProperty.call(dataUpdated, key)) {
                  deliveryData[key] = dataUpdated[key]
                }
              }
            }
          }
        }
      }

      // Add refunds to orders
      const refund = dataUpdated.refund

      if (refund && resolver === 'refund') {
        for (let i = 0; i < state.orders.data.docs.length; i++) {
          const order = state.orders.data.docs[i]
          const refunds = order.refunds

          for (let j = 0; j < refunds.length; j++) {
            const refundData = refunds[j]

            if (refundData.refund === refund) {
              for (const key in dataUpdated) {
                if (Object.hasOwnProperty.call(dataUpdated, key)) {
                  refundData[key] = dataUpdated[key]
                }
              }
            }
          }
        }
      }
    },

    deleteData (state, message) {
      const { dataDeleted, findBy } = message

      let { resolver } = message

      if (resolver[resolver.length - 1] === 'y') {
        resolver = resolver.split('')
        resolver[resolver.length - 1] = 'ie'
        resolver = resolver.join('')
      } else if (resolver[resolver.length - 1] === 's') {
        resolver = resolver + 'e'
      }

      const findIndex = state[`${resolver}s`].data.docs.findIndex(d => String(d[findBy]) === String(dataDeleted[findBy]))
      const findNewIndex = state[`${resolver}s`].new.findIndex(d => String(d[findBy]) === String(dataDeleted[findBy]))

      if (findIndex >= 0) {
        state[`${resolver}s`].data.docs.splice(findIndex, 1)
        state[`${resolver}s`].data.totalDocs--
      }

      if (findNewIndex >= 0) {
        state[`${resolver}s`].new.splice(findNewIndex, 1)
        state[`${resolver}s`].data.totalDocs--
      }
    },

    updateCart (state, message) {
      const { order, cart } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)
      const orderWholesalerFind = state.orderWholesalers.data.docs.find(orderData => orderData.order === order)
      const orderWholesalerFindNew = state.orderWholesalers.new.find(orderData => orderData.order === order)
      const orderFindDropshipping = state.ordersDropshipping.data.docs.find(orderData => orderData.order === order)

      if (orderFindDropshipping) orderFindDropshipping.cart = cart

      if (orderFind) orderFind.cart = cart
      if (orderFindNew) orderFindNew.cart = cart

      if (orderWholesalerFind) orderWholesalerFind.cart = cart
      if (orderWholesalerFindNew) orderWholesalerFindNew.cart = cart

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }

      this.commit('pack/updatePackSearchCart', message)
    },

    updateNewProducts (state, message) {
      const { change, newProducts } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)
      // const changeWholesalerFind = state.changeWholesalers.data.docs.find(changeData => changeData.change === change)
      // const changeWholesalerFindNew = state.changeWholesalers.new.find(changeData => changeData.change === change)
      // const changeFindDropshipping = state.changesDropshipping.data.docs.find(changeData => changeData.change === change)

      // if (changeFindDropshipping) changeFindDropshipping.cart = cart

      if (changeFind) changeFind.newProducts = newProducts
      if (changeFindNew) changeFindNew.newProducts = newProducts

      // if (changeWholesalerFind) changeWholesalerFind.cart = cart
      // if (changeWholesalerFindNew) changeWholesalerFindNew.cart = cart

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'newProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'originalProducts') dataFind[key].push('')
          }
        }
      }

      this.commit('pack/updatePackSearchNewProducts', message)
    },

    updateStatus (state, message) {
      const { order, approvedAt, approvedBy, status, historyStatus, historyCreatedBy } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)
      const orderWholesalerFind = state.orderWholesalers.data.docs.find(orderData => orderData.order === order)
      const orderWholesalerFindNew = state.orderWholesalers.new.find(orderData => orderData.order === order)

      const orderFindDropshipping = state.ordersDropshipping.data.docs.find(orderData => orderData.order === order)

      if (orderFindDropshipping) {
        orderFindDropshipping.status = status
        orderFindDropshipping.declinedAt = approvedAt
        orderFindDropshipping.declinedBy = approvedBy
      }

      if (orderFind) {
        orderFind.status = status
        orderFind.approvedAt = approvedAt
        orderFind.approvedBy = approvedBy
      }

      if (orderWholesalerFind) {
        orderWholesalerFind.status = status
        orderWholesalerFind.approvedAt = approvedAt
        orderWholesalerFind.approvedBy = approvedBy
      }

      if (orderFindNew) {
        orderFindNew.status = status
        orderFindNew.approvedAt = approvedAt
        orderFindNew.approvedBy = approvedBy
      }

      if (orderWholesalerFindNew) {
        orderWholesalerFindNew.status = status
        orderWholesalerFindNew.approvedAt = approvedAt
        orderWholesalerFindNew.approvedBy = approvedBy
      }

      appendOrderStatusHistory(orderFind, status, approvedBy, approvedAt, historyStatus, historyCreatedBy)
      appendOrderStatusHistory(orderFindNew, status, approvedBy, approvedAt, historyStatus, historyCreatedBy)
      appendOrderStatusHistory(orderWholesalerFind, status, approvedBy, approvedAt, historyStatus, historyCreatedBy)
      appendOrderStatusHistory(orderWholesalerFindNew, status, approvedBy, approvedAt, historyStatus, historyCreatedBy)
      appendOrderStatusHistory(orderFindDropshipping, status, approvedBy, approvedAt, historyStatus, historyCreatedBy)

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }

      if (orderWholesalerFind || orderWholesalerFindNew) {
        const dataFind = orderWholesalerFind || orderWholesalerFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusPaid (state, message) {
      const { order, paidAt, paidBy, status, historyStatus, historyCreatedBy } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)

      if (orderFind) {
        orderFind.status = status
        orderFind.paidAt = paidAt
        orderFind.paidBy = paidBy
      }

      if (orderFindNew) {
        orderFindNew.status = status
        orderFindNew.paidAt = paidAt
        orderFindNew.paidBy = paidBy
      }

      appendOrderStatusHistory(orderFind, status, paidBy, paidAt, historyStatus, historyCreatedBy)
      appendOrderStatusHistory(orderFindNew, status, paidBy, paidAt, historyStatus, historyCreatedBy)

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }
    },

    updatePayManual (state, message) {
      const { order, payManual } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)

      if (orderFind) orderFind.payManual = payManual

      if (orderFindNew) orderFindNew.payManual = payManual

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }
    },

    updatePayManualChange (state, message) {
      const { change, payManual } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      if (changeFind) changeFind.payManual = payManual

      if (changeFindNew) changeFindNew.payManual = payManual

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'originalProducts' && key !== 'newProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }
    },

    updatePayU (state, message) {
      const { order, payU } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)

      if (orderFind) orderFind.payU = payU

      if (orderFindNew) orderFindNew.payU = payU

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusPacked (state, message) {
      const { order, packedAt, packedBy, status, historyStatus, historyCreatedBy } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)

      if (orderFind) {
        orderFind.status = status
        orderFind.packedAt = packedAt
        orderFind.packedBy = packedBy
      }

      if (orderFindNew) {
        orderFindNew.status = status
        orderFindNew.packedAt = packedAt
        orderFindNew.packedBy = packedBy
      }

      appendOrderStatusHistory(orderFind, status, packedBy, packedAt, historyStatus, historyCreatedBy)
      appendOrderStatusHistory(orderFindNew, status, packedBy, packedAt, historyStatus, historyCreatedBy)

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }

      this.commit('pack/updatePackSearchStatus', message)
    },

    updateStatusPackedChange (state, message) {
      const { change, packedAt, packedBy, status } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      if (changeFind) {
        changeFind.status = status
        changeFind.packedAt = packedAt
        changeFind.packedBy = packedBy
      }

      if (changeFindNew) {
        changeFindNew.status = status
        changeFindNew.packedAt = packedAt
        changeFindNew.packedBy = packedBy
      }

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'originalProducts' && key !== 'newProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }

      this.commit('pack/updatePackSearchStatus', message)
    },

    updateStatusChangeApproved (state, message) {
      const { change, approvedAt, approvedBy, status } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      if (changeFind) {
        changeFind.status = status
        changeFind.approvedAt = approvedAt
        changeFind.approvedBy = approvedBy
      }

      if (changeFindNew) {
        changeFindNew.status = status
        changeFindNew.approvedAt = approvedAt
        changeFindNew.approvedBy = approvedBy
      }

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'newProducts' && key !== 'originalProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusChangePaid (state, message) {
      const { change, paidAt, paidBy, status } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      if (changeFind) {
        changeFind.status = status
        changeFind.paidAt = paidAt
        changeFind.paidBy = paidBy
      }

      if (changeFindNew) {
        changeFindNew.status = status
        changeFindNew.paidAt = paidAt
        changeFindNew.paidBy = paidBy
      }

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'newProducts' && key !== 'originalProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusSent (state, message) {
      const { order, sentAt, sentBy, status, historyStatus, historyCreatedBy } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)

      if (orderFind) {
        orderFind.status = status
        orderFind.sentAt = sentAt
        orderFind.sentBy = sentBy
      }

      if (orderFindNew) {
        orderFindNew.status = status
        orderFindNew.sentAt = sentAt
        orderFindNew.sentBy = sentBy
      }

      appendOrderStatusHistory(orderFind, status, sentBy, sentAt, historyStatus, historyCreatedBy)
      appendOrderStatusHistory(orderFindNew, status, sentBy, sentAt, historyStatus, historyCreatedBy)

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }

      this.commit('pack/updatePackSearchStatus', message)
    },

    updateStatusGift (state, message) {
      const { status, phone } = message

      const giftVoucherFind = state.giftVouchers.data.docs.find(phoneData => phoneData.phone === phone)
      const giftVoucherFindNew = state.giftVouchers.new.find(phoneData => phoneData.phone === phone)

      if (giftVoucherFind) {
        giftVoucherFind.status = status
      }

      if (giftVoucherFindNew) {
        giftVoucherFindNew.status = status
      }
    },

    updateMethodPayGift (state, message) {
      const { methodPay, phone } = message

      const giftVoucherFind = state.giftVouchers.data.docs.find(phoneData => phoneData.phone === phone)
      const giftVoucherFindNew = state.giftVouchers.new.find(phoneData => phoneData.phone === phone)

      if (giftVoucherFind) {
        giftVoucherFind.methodPay = methodPay
      }

      if (giftVoucherFindNew) {
        giftVoucherFindNew.methodPay = methodPay
      }
    },

    updateStatusSentChange (state, message) {
      const { change, sentAt, sentBy, status } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      if (changeFind) {
        changeFind.status = status
        changeFind.sentAt = sentAt
        changeFind.sentBy = sentBy
      }

      if (changeFindNew) {
        changeFindNew.status = status
        changeFindNew.sentAt = sentAt
        changeFindNew.sentBy = sentBy
      }

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'originalProducts' && key !== 'newProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }

      this.commit('pack/updatePackSearchStatus', message)
    },

    updateStatusDeclined (state, message) {
      const { order, declinedAt, declinedBy, status } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)
      const orderWholesalerFind = state.orderWholesalers.data.docs.find(orderData => orderData.order === order)

      const orderFindDropshipping = state.ordersDropshipping.data.docs.find(orderData => orderData.order === order)

      if (orderFindDropshipping) {
        orderFindDropshipping.status = status
        orderFindDropshipping.declinedAt = declinedAt
        orderFindDropshipping.declinedBy = declinedBy
      }

      if (orderFind) {
        orderFind.status = status
        orderFind.declinedAt = declinedAt
        orderFind.declinedBy = declinedBy
      }

      if (orderWholesalerFind) {
        orderWholesalerFind.status = status
        orderWholesalerFind.declinedAt = declinedAt
        orderWholesalerFind.declinedBy = declinedBy
      }

      appendOrderStatusHistory(orderFind, status, declinedBy, declinedAt)
      appendOrderStatusHistory(orderFindNew, status, declinedBy, declinedAt)
      appendOrderStatusHistory(orderWholesalerFind, status, declinedBy, declinedAt)
      appendOrderStatusHistory(orderFindDropshipping, status, declinedBy, declinedAt)

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }

      if (orderWholesalerFind) {
        const dataFind = orderWholesalerFind

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusDeclinedChange (state, message) {
      const { change, declinedAt, declinedBy, status } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      /* const changeFindDropshipping = state.changesDropshipping.data.docs.find(changeData => changeData.change === change)

      if (changeFindDropshipping) {
        changeFindDropshipping.status = status
        changeFindDropshipping.declinedAt = declinedAt
        changeFindDropshipping.declinedBy = declinedBy
      } */

      if (changeFind) {
        changeFind.status = status
        changeFind.declinedAt = declinedAt
        changeFind.declinedBy = declinedBy
      }

      if (changeFindNew) {
        changeFindNew.status = status
        changeFindNew.declinedAt = declinedAt
        changeFindNew.declinedBy = declinedBy
      }

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'newProducts' && key !== 'originalProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }
    },

    updatePackReceived (state, message) {
      const { change, packReceived, packReceivedBy, packReceivedAt } = message

      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      /* const changeFindDropshipping = state.changesDropshipping.data.docs.find(changeData => changeData.change === change)

      if (changeFindDropshipping) {
        changeFindDropshipping.status = status
        changeFindDropshipping.declinedAt = declinedAt
        changeFindDropshipping.declinedBy = declinedBy
      } */

      if (changeFind) {
        changeFind.packReceived = packReceived
        changeFind.packReceivedAt = packReceivedAt
        changeFind.packReceivedBy = packReceivedBy
      }

      if (changeFindNew) {
        changeFindNew.packReceived = packReceived
        changeFindNew.packReceivedAt = packReceivedAt
        changeFindNew.packReceivedBy = packReceivedBy
      }

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'newProducts' && key !== 'originalProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusExpired (state, message) {
      const { order, status } = message

      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)

      if (orderFind) {
        orderFind.status = status
      }

      if (orderFindNew) {
        orderFindNew.status = status
      }

      appendOrderStatusHistory(orderFind, status, 'system')
      appendOrderStatusHistory(orderFindNew, status, 'system')

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }
    },

    addObservation (state, message) {
      const { order } = message
      const orderFind = state.orders.data.docs.find(orderData => orderData.order === order)
      const orderFindNew = state.orders.new.find(orderData => orderData.order === order)

      if (orderFind) {
        if (!orderFind.observations) orderFind.observations = []
        orderFind.observations.push(message)
      }

      if (orderFindNew) {
        if (!orderFindNew.observations) orderFindNew.observations = []
        orderFindNew.observations.push(message)
      }

      if (orderFind || orderFindNew) {
        const dataFind = orderFind || orderFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'cart' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied' && key !== 'changes' && key !== 'statusHistory' && key !== 'remitData') dataFind[key].push('')
          }
        }
      }
    },

    updateOrderNotifications (state, message) {
      const { order, notifications } = message
      if (!order) return

      const apply = (doc) => {
        if (!doc) return
        Vue.set(doc, 'notifications', notifications || { history: [] })
      }

      apply(state.orders.data.docs.find(d => d.order === order))
      apply(state.orders.new.find(d => d.order === order))
      apply(state.orderWholesalers.data.docs.find(d => d.order === order))
      apply(state.orderWholesalers.new.find(d => d.order === order))
      apply(state.ordersDropshipping.data.docs.find(d => d.order === order))
      apply(state.ordersDropshipping.new.find(d => d.order === order))
    },

    addObservationChange (state, message) {
      const { change } = message
      const changeFind = state.changes.data.docs.find(changeData => changeData.change === change)
      const changeFindNew = state.changes.new.find(changeData => changeData.change === change)

      if (changeFind) {
        if (!changeFind.observations) changeFind.observations = []
        changeFind.observations.push(message)
      }

      if (changeFindNew) {
        if (!changeFindNew.observations) changeFindNew.observations = []
        changeFindNew.observations.push(message)
      }

      if (changeFind || changeFindNew) {
        const dataFind = changeFind || changeFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'newProducts' && key !== 'originalProducts' && key !== 'observations' && key !== 'payU' && key !== 'payManual' && key !== 'deliveries' && key !== 'refunds' && key !== 'invoices' && key !== 'bonuses' && key !== 'bonusesApplied') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusInProgress (state, message) {
      const { delivery, inProgressAt, inProgressBy, status } = message

      const deliveryFind = state.deliveries.data.docs.find(deliveryData => deliveryData.delivery === delivery)
      const deliveryFindNew = state.deliveries.new.find(deliveryData => deliveryData.delivery === delivery)

      if (deliveryFind) {
        deliveryFind.status = status
        deliveryFind.inProgressAt = inProgressAt
        deliveryFind.inProgressBy = inProgressBy
      }

      if (deliveryFindNew) {
        deliveryFindNew.status = status
        deliveryFindNew.inProgressAt = inProgressAt
        deliveryFindNew.inProgressBy = inProgressBy
      }

      if (deliveryFind || deliveryFindNew) {
        const dataFind = deliveryFind || deliveryFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'phones') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusDeliveryDeclined (state, message) {
      const { delivery, declinedAt, declinedBy, status } = message

      this.commit('mass/updateMassDeliveryFromSocket', message)

      const deliveryFind = state.deliveries.data.docs.find(deliveryData => deliveryData.delivery === delivery)
      const deliveryFindNew = state.deliveries.new.find(deliveryData => deliveryData.delivery === delivery)

      if (deliveryFind) {
        deliveryFind.status = status
        deliveryFind.declinedAt = declinedAt
        deliveryFind.declinedBy = declinedBy
      }

      if (deliveryFindNew) {
        deliveryFindNew.status = status
        deliveryFindNew.declinedAt = declinedAt
        deliveryFindNew.declinedBy = declinedBy
      }

      if (deliveryFind || deliveryFindNew) {
        const dataFind = deliveryFind || deliveryFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'phones') dataFind[key].push('')
          }
        }
      }
    },

    updateStatusDelivered (state, message) {
      const { delivery, deliveredAt, deliveredBy, leftBuildingReception, status } = message

      const deliveryFind = state.deliveries.data.docs.find(deliveryData => deliveryData.delivery === delivery)
      const deliveryFindNew = state.deliveries.new.find(deliveryData => deliveryData.delivery === delivery)

      if (deliveryFind) {
        deliveryFind.status = status
        deliveryFind.deliveredAt = deliveredAt
        deliveryFind.deliveredBy = deliveredBy
        deliveryFind.leftBuildingReception = leftBuildingReception
      }

      if (deliveryFindNew) {
        deliveryFindNew.status = status
        deliveryFindNew.deliveredAt = deliveredAt
        deliveryFindNew.deliveredBy = deliveredBy
        deliveryFindNew.leftBuildingReception = leftBuildingReception
      }

      if (deliveryFind || deliveryFindNew) {
        const dataFind = deliveryFind || deliveryFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'phones') dataFind[key].push('')
          }
        }
      }
    },

    updateDeliveryPaid (state, message) {
      const { delivery, paidAt, paidBy } = message

      const deliveryFind = state.deliveries.data.docs.find(deliveryData => deliveryData.delivery === delivery)
      const deliveryFindNew = state.deliveries.new.find(deliveryData => deliveryData.delivery === delivery)

      if (deliveryFind) {
        deliveryFind.paidAt = paidAt
        deliveryFind.paidBy = paidBy
      }

      if (deliveryFindNew) {
        deliveryFindNew.paidAt = paidAt
        deliveryFindNew.paidBy = paidBy
      }

      if (deliveryFind || deliveryFindNew) {
        const dataFind = deliveryFind || deliveryFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'phones') dataFind[key].push('')
          }
        }
      }
    },

    updateChargeCollected (state, message) {
      const { delivery, collectedAt, collectedBy } = message

      const deliveryFind = state.deliveries.data.docs.find(deliveryData => deliveryData.delivery === delivery)
      const deliveryFindNew = state.deliveries.new.find(deliveryData => deliveryData.delivery === delivery)

      if (deliveryFind) {
        deliveryFind.collectedAt = collectedAt
        deliveryFind.collectedBy = collectedBy
      }

      if (deliveryFindNew) {
        deliveryFindNew.collectedAt = collectedAt
        deliveryFindNew.collectedBy = collectedBy
      }

      if (deliveryFind || deliveryFindNew) {
        const dataFind = deliveryFind || deliveryFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'phones') dataFind[key].push('')
          }
        }
      }
    },

    addObservationDelivery (state, message) {
      const { delivery } = message
      const deliveryFind = state.deliveries.data.docs.find(orderData => orderData.delivery === delivery)
      const deliveryFindNew = state.deliveries.new.find(orderData => orderData.delivery === delivery)

      if (deliveryFind) {
        if (!deliveryFind.observations) deliveryFind.observations = []
        deliveryFind.observations.push(message)
      }

      if (deliveryFindNew) {
        if (!deliveryFindNew.observations) deliveryFindNew.observations = []
        deliveryFindNew.observations.push(message)
      }

      if (deliveryFind || deliveryFindNew) {
        const dataFind = deliveryFind || deliveryFindNew

        for (const key in dataFind) {
          if (dataFind.hasOwnProperty(key)) {
            // Solucionar esto, lo hice para que no agregara nada al final del carro
            if (Array.isArray(dataFind[key]) && dataFind[key][dataFind[key].length - 1] !== '' && key !== 'phones') dataFind[key].push('')
          }
        }
      }
    }
  },

  actions: {
    getVariablesApp ({ rootState }) {
      mDB.methods.getVariablesApp(rootState, gqlApp)
    },

    async getData ({ rootState, state }, options) {
      state.isLoading = true
      const { resolver, page, key } = options
      const originalResolver = resolver.replace('History', '')
      const isHistory = resolver.indexOf('History') >= 0
      await mDB.methods.getData(rootState, state, gqlQueries[originalResolver], resolver, page, key, isHistory)
      state.isLoading = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/data.js